import styled from '@emotion/styled'

const GateForContentButtonWrapper = styled.div`
    ${({ theme }) => theme.breakpoints.down("xl")}{
        padding-right: 30px;
    }
`

export default GateForContentButtonWrapper